import { useMask } from "@react-input/mask";
import Input from "components/input";
import moment from "moment";
import React, { forwardRef } from "react";
import ReactDatePicker from "react-datepicker";
import { twMerge } from "tailwind-merge";

type InputProps = {
  placeholder?: string;
  id?: string;
  label?: string;
  error?: any;
  type?: string;
  [x: string]: any;
};

const CustomInput = forwardRef<HTMLInputElement, InputProps>((props, ref) => {
  const inputRef = useMask({
    mask: "__/__/____ __:__",
    replacement: { _: /\d/ },
  });
  return <Input type="text" ref={inputRef} {...props} />
})
const DateTimePicker = React.forwardRef((props: InputProps, ref: any) => {
  return (
    <ReactDatePicker 
      selected={props.value ? moment(props.value).toDate() : null}
      onChange={props.onChange}
      wrapperClassName="w-full"
      className={twMerge(
        `input ${
          props.error
            ? "border-red-600 focus:border-red-600"
            : "border-gray-300 focus:border-brand-500"
        }`,
        props.className
      )}
      placeholderText={props.placeholder ? `${props.placeholder} (dd/mm/yyyy HH:mm)` : "dd/mm/yyyy HH:mm"}
      dateFormat="dd/MM/yyyy HH:mm"
      showTimeInput
      ref={ref}
      customInput={(<CustomInput onChange={props.onChange} />)}
    />
  )
});

DateTimePicker.displayName = "DateTimePicker";

export default DateTimePicker;
